import styled, { css } from 'styled-components'

export const FormInput = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;

  ${props => {
    if (props.invalid) {
      return css`
        span {
          opacity: 1 !important;
        }

        .input-wrapper {
          border-color: var(--danger) !important;
        }
      `
    }
  }}
`

export const Label = styled.label`
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
  color: var(--text);
  margin-bottom: 11.3px;

  strong {
    font-weight: 400;
    color: var(--danger);
  }
`

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  
  border: 1px solid var(--greyLight);
  border-radius: 50px;
  color: var(--textDark);
  padding: 11.9px 21px;
  width: 100%;

  .icon {
    display: flex;
    width: 15px;
    height: 15px;
    fill: var(--greyLight);
  }

  ${props => {
    if (props.disabled) {
      return css`
        border-color: var(--light);
        background-color: var(--light);
        pointer-events: none;
     `
    }
  }}
`

export const Input = styled.input`
  font-family: 'Nunito', sans-serif;
  font-size: 15px;

  background-color: transparent;
  border: none;
  color: inherit;

  width: 100%;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;

  &:focus, &:focus-visible {
    outline: none;
  }
`

export const Span = styled.span`
  display: block;
  opacity: 0;
  height: 12px;

  font-family: 'Nunito', sans-serif;
  font-size: 9px;
  font-weight: 400;
  color: var(--danger);
`
